import React, { useEffect, useReducer, useState } from "react";
import "./DashboardRegisterDetailPage.css";
import {
  Alert,
  Avatar,
  Button,
  Checkbox,
  Divider,
  Grid,
  Group,
  Image,
  Radio,
  Select,
  Table,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import { useNavigate } from "react-router-dom";
import AppModelConfrimSave from "../../(dialogs)/AppModelConfrimSave";
import { IconAlertCircle, IconX } from "@tabler/icons-react";
import DetailUser from "../component/DetailUser";
import AppModelConfrimRemove from "../../(dialogs)/AppModelConfrimRemove";
import { useForm } from "@mantine/form";
import { url } from "../../settings/linkUrl";
import { notifications } from "@mantine/notifications";

interface RowDataUser {
  id: string;
  url: string;
  faculty: string;
  programe: string;
  short_name: string;
  name: string;
  role: string;
}

interface RowMoney {
  register: string;
  photo: string;
  set: string;
  rentset: string;
  register_and_photo: string;
  frm_register: string;
  frm_photo: string;
  frm_set: string;
  frm_rentset: string;
  frm_register_and_photo: string;
}

export default function DashboardRegisterDetailPage() {
  const nav = useNavigate();
  const [dataUser, SetdataUser] = useState<RowDataUser>();
  const [dataMoney, SetdataMoney] = useState<RowMoney>();

  const [valueRegister, setValueRegister] = useState<string[]>(["1"]);

  const [dataProvince, setProvince] = useState([]);
  const [dataDistrict, setDistrict] = useState([]);
  const [dataSubDistrict, setSubDistrict] = useState([]);

  const [dataDistrictSet, setDistrictSet] = useState([]);
  const [dataSubDistrictSet, setSubDistrictSet] = useState([]);

  const form = useForm({
    initialValues: {
      register: "1",
      photo: "0",
      set: "0",
      rentset: "0",
      register_and_photo: "0",
      photo_phone: "",
      photo_number: "",
      photo_moo: "",
      photo_soi: "",
      photo_street: "",
      photo_privancy: "",
      photo_district: "",
      photo_subdistrict: "",
      photo_zipcode: "",
      set_sent: "1",
      set_size: "L",
      set_chest: "",
      set_shoulder: "",
      set_sleeve: "",
      set_hemshirt: "",
      set_phone: "-",
      set_number: "-",
      set_moo: "-",
      set_soi: "-",
      set_street: "-",
      set_privancy: "-",
      set_district: "-",
      set_subdistrict: "-",
      set_zipcode: "-",
      set_copy: "0",
    },
    validate: (values) => {
      const errors: Record<string, string> = {};

      if (values.photo === "1") {
        if (!values.photo_number?.trim()) errors.photo_number = "ระบุบ้านเลขที่";
        if (!values.photo_moo?.trim()) errors.photo_moo = "ระบุหมู่ที่";
        if (!values.photo_privancy?.trim()) errors.photo_privancy = "ระบุจังหวัด";
        if (!values.photo_district?.trim()) errors.photo_district = "ระบุอำเภอ";
        if (!values.photo_subdistrict?.trim())
          errors.photo_subdistrict = "ระบุตำบล";
        if (!values.photo_zipcode?.trim())
          errors.photo_zipcode = "ระบุรหัสไปรษณีย์";
        if (!values.photo_phone?.trim()) errors.photo_phone = "ระบุเบอร์โทรศัพท์";
      }

      if (values.set === "1" || values.rentset === "1") {
        if (!values.set_size?.trim()) errors.set_size = "ระบุไซส์";
        if (!values.set_chest?.trim()) errors.set_chest = "ระบุความกว้างอก";
        if (!values.set_shoulder?.trim())
          errors.set_shoulder = "ระบุความกว้างช่วงหัวไหล่";
        if (!values.set_sleeve?.trim()) errors.set_sleeve = "ระบุความยาวแขนเสื้อ";
        if (!values.set_hemshirt?.trim())
          errors.set_hemshirt = "ระบุความยาวชายชุดครุย";

        if (values.set_sent === "2") {
          if (!values.set_copy?.trim()) errors.set_copy = "ระบุการคัดลอกที่อยู่";
          if (!values.set_phone?.trim()) errors.set_phone = "ระบุเบอร์โทรศัพท์";
          if (!values.set_number?.trim()) errors.set_number = "ระบุบ้านเลขที่";
          if (!values.set_moo?.trim()) errors.set_moo = "ระบุหมู่ที่";
          if (!values.set_privancy?.trim()) errors.set_privancy = "ระบุจังหวัด";
          if (!values.set_district?.trim()) errors.set_district = "ระบุอำเภอ";
          if (!values.set_subdistrict?.trim())
            errors.set_subdistrict = "ระบุตำบล";
          if (!values.set_zipcode?.trim())
            errors.set_zipcode = "ระบุรหัสไปรษณีย์";
        }
      }

      return errors;
    },
  });

  const initialState = {
    loading: "",
    error: "",
    data: [],
  };

  function apiReducer(state: any, action: any) {
    switch (action.type) {
      case "DATA_FETCH_START":
        return { ...state, loading: "yes" };
      case "DATA_FETCH_SUCCESS":
        return { ...state, loading: "", data: action.payload };
      case "DATA_FETCH_FAILURE":
        return { ...state, loading: "", error: action.payload };
      default:
        return state;
    }
  }

  const [data, dispatch] = useReducer(apiReducer, initialState);

  const LoadPage = () => {
    let rr: any = localStorage.getItem("dataUser");
    SetdataUser(JSON.parse(rr));

    dispatch({ type: "DATA_FETCH_START" });
    const token = localStorage.getItem("token");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    fetch(`${url}register/checkdetail`, requestOptions)
      .then((respone) => {
        if (!respone.ok) throw Error(respone.statusText);
        return respone.json();
      })
      .then((json) => {
        dispatch({ type: "DATA_FETCH_SUCCESS", payload: json });
        SetdataMoney(json);
        form.setFieldValue("register", json.frm_register);
        form.setFieldValue("photo", json.frm_photo);
        form.setFieldValue("set", json.frm_set);
        form.setFieldValue("rentset", json.frm_rentset);
        form.setFieldValue("register_and_photo", json.frm_register_and_photo);

        if (json.frm_photo !== "1") {
          form.setFieldValue("photo_phone", "-");
          form.setFieldValue("photo_number", "-");
          form.setFieldValue("photo_moo", "-");
          form.setFieldValue("photo_soi", "-");
          form.setFieldValue("photo_street", "-");
          form.setFieldValue("photo_privancy", "-");
          form.setFieldValue("photo_district", "-");
          form.setFieldValue("photo_subdistrict", "-");
          form.setFieldValue("photo_zipcode", "-");
          form.setFieldValue("set_copy", "0");
        }

        if (json.frm_set === "0" && json.frm_set === "0") {
          form.setFieldValue("set_sent", "-");
          form.setFieldValue("set_size", "-");
          form.setFieldValue("set_chest", "-");
          form.setFieldValue("set_shoulder", "-");
          form.setFieldValue("set_sleeve", "-");
          form.setFieldValue("set_hemshirt", "-");
          form.setFieldValue("set_phone", "-");
          form.setFieldValue("set_number", "-");
          form.setFieldValue("set_moo", "-");
          form.setFieldValue("set_soi", "-");
          form.setFieldValue("set_street", "-");
          form.setFieldValue("set_privancy", "-");
          form.setFieldValue("set_district", "-");
          form.setFieldValue("set_subdistrict", "-");
          form.setFieldValue("set_zipcode", "-");
          form.setFieldValue("set_copy", "0");
        }

        if (form.values.set_size !== "Outher") {
          form.setFieldValue("set_chest", "-");
          form.setFieldValue("set_shoulder", "-");
          form.setFieldValue("set_sleeve", "-");
          form.setFieldValue("set_hemshirt", "-");
        }

        if (form.values.set_copy === "2") {
          form.setFieldValue("set_phone", "");
          form.setFieldValue("set_number", "");
          form.setFieldValue("set_moo", "");
          form.setFieldValue("set_soi", "");
          form.setFieldValue("set_street", "");
          form.setFieldValue("set_privancy", "");
          form.setFieldValue("set_district", "");
          form.setFieldValue("set_subdistrict", "");
          form.setFieldValue("set_zipcode", "");
        } else {
          form.setFieldValue("set_phone", "-");
          form.setFieldValue("set_number", "-");
          form.setFieldValue("set_moo", "-");
          form.setFieldValue("set_soi", "-");
          form.setFieldValue("set_street", "-");
          form.setFieldValue("set_privancy", "-");
          form.setFieldValue("set_district", "-");
          form.setFieldValue("set_subdistrict", "-");
          form.setFieldValue("set_zipcode", "-");
        }

        loadPrivancy();
      })
      .catch((error) => {
        dispatch({ type: "DATA_FETCH_FAILURE", payload: error.message });
      });
  };

  const loadPrivancy = () => {
    dispatch({ type: "DATA_FETCH_START" });
    const token = localStorage.getItem("token");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    fetch(`${url}register/province`, requestOptions)
      .then((respone) => {
        if (!respone.ok) throw Error(respone.statusText);
        return respone.json();
      })
      .then((json) => {
        dispatch({ type: "DATA_FETCH_SUCCESS", payload: json });
        setProvince(json);
      })
      .catch((error) => {
        dispatch({ type: "DATA_FETCH_FAILURE", payload: error.message });
      });
  };

  const loadDistrict = () => {
    dispatch({ type: "DATA_FETCH_START" });
    console.log(form.values);
    const token = localStorage.getItem("token");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    fetch(
      `${url}register/district/${form.values.photo_privancy}`,
      requestOptions
    )
      .then((respone) => {
        if (!respone.ok) throw Error(respone.statusText);
        return respone.json();
      })
      .then((json) => {
        dispatch({ type: "DATA_FETCH_SUCCESS", payload: json });
        setDistrict(json);
      })
      .catch((error) => {
        dispatch({ type: "DATA_FETCH_FAILURE", payload: error.message });
      });
  };

  const loadSubDistrict = () => {
    dispatch({ type: "DATA_FETCH_START" });
    console.log(form.values);
    const token = localStorage.getItem("token");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    fetch(
      `${url}register/subdistrict/${form.values.photo_privancy}/${form.values.photo_district}`,
      requestOptions
    )
      .then((respone) => {
        if (!respone.ok) throw Error(respone.statusText);
        return respone.json();
      })
      .then((json) => {
        dispatch({ type: "DATA_FETCH_SUCCESS", payload: json });
        setSubDistrict(json);
      })
      .catch((error) => {
        dispatch({ type: "DATA_FETCH_FAILURE", payload: error.message });
      });
  };

  const loadDistrictSet = () => {
    dispatch({ type: "DATA_FETCH_START" });
    console.log(form.values);
    const token = localStorage.getItem("token");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    fetch(`${url}register/district/${form.values.set_privancy}`, requestOptions)
      .then((respone) => {
        if (!respone.ok) throw Error(respone.statusText);
        return respone.json();
      })
      .then((json) => {
        dispatch({ type: "DATA_FETCH_SUCCESS", payload: json });
        setDistrictSet(json);
      })
      .catch((error) => {
        dispatch({ type: "DATA_FETCH_FAILURE", payload: error.message });
      });
  };

  const loadSubDistrictSet = () => {
    dispatch({ type: "DATA_FETCH_START" });
    console.log(form.values);
    const token = localStorage.getItem("token");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    fetch(
      `${url}register/subdistrict/${form.values.set_privancy}/${form.values.set_district}`,
      requestOptions
    )
      .then((respone) => {
        if (!respone.ok) throw Error(respone.statusText);
        return respone.json();
      })
      .then((json) => {
        dispatch({ type: "DATA_FETCH_SUCCESS", payload: json });
        setSubDistrictSet(json);
      })
      .catch((error) => {
        dispatch({ type: "DATA_FETCH_FAILURE", payload: error.message });
      });
  };

  useEffect(() => {
    LoadPage();
  }, []);

  const funcSubmit = () => {
    dispatch({ type: "DATA_FETCH_START" });
    const token = localStorage.getItem("token");
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(form.values),
    };
    fetch(`${url}register/showdetail`, requestOptions)
      .then((respone) => {
        if (!respone.ok) throw Error(respone.statusText);
        return respone.json();
      })
      .then((json) => {
        dispatch({ type: "DATA_FETCH_SUCCESS", payload: json });
        if (json.data.success === "1") {
          notifications.show({
            title: "แจ้งเตือน",
            message: "บันทึกข้อมูลเรียบร้อย",
            autoClose: 3000,
            color: "green",
            icon: <IconAlertCircle />,
          });
          nav(`/dashboard/use-payment`);
        }
      })
      .catch((error) => {
        dispatch({ type: "DATA_FETCH_FAILURE", payload: error.message });
      });
  };

  const setSetSize = (e: string) => {
    form.setFieldValue("set_size", e);
    if (e === "Outher") {
      form.setFieldValue("set_chest", "");
      form.setFieldValue("set_shoulder", "");
      form.setFieldValue("set_sleeve", "");
      form.setFieldValue("set_hemshirt", "");
    } else {
      form.setFieldValue("set_chest", "-");
      form.setFieldValue("set_shoulder", "-");
      form.setFieldValue("set_sleeve", "-");
      form.setFieldValue("set_hemshirt", "-");
    }
  };

  const setSetSent = (e: string) => {
    form.setFieldValue("set_sent", e);
    if (e === "2") {
      // ไม่มีรูปภาพ → ให้กรอกที่อยู่ชุดครุยเองเท่านั้น
      if (form.values.photo !== "1") {
        form.setFieldValue("set_copy", "0");
      }
      form.setFieldValue("set_phone", "");
      form.setFieldValue("set_number", "");
      form.setFieldValue("set_moo", "");
      form.setFieldValue("set_soi", "");
      form.setFieldValue("set_street", "");
      form.setFieldValue("set_privancy", "");
      form.setFieldValue("set_district", "");
      form.setFieldValue("set_subdistrict", "");
      form.setFieldValue("set_zipcode", "");
    } else {
      form.setFieldValue("set_phone", "-");
      form.setFieldValue("set_number", "-");
      form.setFieldValue("set_moo", "-");
      form.setFieldValue("set_soi", "-");
      form.setFieldValue("set_street", "-");
      form.setFieldValue("set_privancy", "-");
      form.setFieldValue("set_district", "-");
      form.setFieldValue("set_subdistrict", "-");
      form.setFieldValue("set_zipcode", "-");
    }
  };

  const setSetCopy = (e: string) => {
    form.setFieldValue("set_copy", e);
    console.log(e);
    if (e === "0") {
      form.setFieldValue("set_phone", "");
      form.setFieldValue("set_number", "");
      form.setFieldValue("set_moo", "");
      form.setFieldValue("set_soi", "");
      form.setFieldValue("set_street", "");
      form.setFieldValue("set_privancy", "");
      form.setFieldValue("set_district", "");
      form.setFieldValue("set_subdistrict", "");
      form.setFieldValue("set_zipcode", "");
    } else {
      console.log(form.values.photo_phone);
      if (form.values.photo_phone === "") {
        form.setFieldValue("set_phone", "-");
        form.setFieldValue("set_number", "-");
        form.setFieldValue("set_moo", "-");
        form.setFieldValue("set_soi", "-");
        form.setFieldValue("set_street", "-");
        form.setFieldValue("set_privancy", "-");
        form.setFieldValue("set_district", "-");
        form.setFieldValue("set_subdistrict", "-");
        form.setFieldValue("set_zipcode", "-");
      } else {
        form.setFieldValue("set_phone", form.values.photo_phone);
        form.setFieldValue("set_number", form.values.photo_number);
        form.setFieldValue("set_moo", form.values.photo_moo);
        form.setFieldValue("set_soi", form.values.photo_soi);
        form.setFieldValue("set_street", form.values.photo_street);
        form.setFieldValue("set_privancy", form.values.photo_privancy);
        form.setFieldValue("set_district", form.values.photo_district);
        form.setFieldValue("set_subdistrict", form.values.photo_subdistrict);
        form.setFieldValue("set_zipcode", form.values.photo_zipcode);
      }
    }
  };

  return (
    <div className="DashboardSelectRegisterPage">
      <section>
        <DetailUser />
      </section>
      <Divider my="xs" size="md" color="blue" />
      <section>
        {/* onSubmit={form.onSubmit(funcSubmit)} */}
        <form onSubmit={form.onSubmit(funcSubmit)}>
          <Title c="blue" order={3}>
            ลงทะเบียนเข้าซ้อมรับพระราชทานปริญญาบัตร
          </Title>
          {form.values.photo === "1" && (
            <>
              <Text c="blue" size="lg">
                ที่อยู่สำหรับจัดส่งรูปภาพ
              </Text>
              <Grid>
                <Grid.Col
                  span={{ base: 12, md: 6, xl: 6, sm: 6, lg: 6 }}
                  pr={20}
                  pl={20}
                >
                  <TextInput
                    withAsterisk
                    mt="sm"
                    label="บ้านเลขที่"
                    placeholder="บ้านเลขที่"
                    {...form.getInputProps("photo_number")}
                  />
                  <TextInput
                    withAsterisk
                    mt="sm"
                    label="หมู่ที่"
                    placeholder="หมู่ที่"
                    {...form.getInputProps("photo_moo")}
                  />
                  <TextInput
                    mt="sm"
                    label="ซอย"
                    placeholder="ซอย"
                    {...form.getInputProps("photo_soi")}
                  />
                  <TextInput
                    mt="sm"
                    label="ถนน"
                    placeholder="ถนน"
                    {...form.getInputProps("photo_street")}
                  />
                </Grid.Col>
                <Grid.Col
                  span={{ base: 12, md: 6, xl: 6, sm: 6, lg: 6 }}
                  pr={20}
                  pl={20}
                >
                  <Select
                    label="จังหวัด"
                    placeholder="จังหวัด"
                    withAsterisk
                    mt="sm"
                    data={dataProvince}
                    onDropdownClose={() => setDistrict([])}
                    {...form.getInputProps("photo_privancy")}
                  />

                  <Select
                    label="อำเภอ"
                    placeholder="อำเภอ"
                    withAsterisk
                    mt="sm"
                    data={dataDistrict}
                    onDropdownClose={() => setSubDistrict([])}
                    onDropdownOpen={loadDistrict}
                    {...form.getInputProps("photo_district")}
                  />
                  <Select
                    label="ตำบล"
                    placeholder="ตำบล"
                    withAsterisk
                    mt="sm"
                    data={dataSubDistrict}
                    onDropdownOpen={loadSubDistrict}
                    {...form.getInputProps("photo_subdistrict")}
                  />

                  <TextInput
                    mt="sm"
                    label="รหัสไปรษณีย์"
                    placeholder="รหัสไปรษณีย์"
                    withAsterisk
                    maxLength={5}
                    {...form.getInputProps("photo_zipcode")}
                  />

                  <TextInput
                    mt="sm"
                    label="เบอร์โทรศัพท์"
                    placeholder="เบอร์โทรศัพท์"
                    withAsterisk
                    {...form.getInputProps("photo_phone")}
                  />
                </Grid.Col>
              </Grid>
            </>
          )}
          {form.values.set === "1" || form.values.rentset === "1" ? (
            <>
              <Group>
                <Text c="blue" size="lg" mt="md" mb="md">
                  ระบุไซส์ครุยวิทยฐานะ
                </Text>
                <div>
                  <Button
                    color="dark"
                    radius="md"
                    size="xs"
                    component="a"
                    target="_blank"
                    href={`${url}public/การวัดขนาดชุดครุยวิทยฐานะ.pdf`}
                  >
                    ขั้นตอนการตรวจสอบไซส์ครุยวิทยฐานะ
                  </Button>
                </div>
              </Group>
              <Grid>
                <Grid.Col span={{base:12, md:12 , xl:12, sm:12 , lg:12}} pr={20} pl={20}>
                  <Radio.Group
                    {...form.getInputProps("set_size")}
                    onChange={setSetSize}
                  >
                    <Radio
                      mb="md"
                      value="SSS"
                      label="ไซส์ SSS"
                      description="ความกว้างอก 29-40 นิ้ว ความกว้างช่วงหัวไหล่ 15 นิ้ว ความยาวแขนเสื้อ 15 นิ้ว ความยาวชายชุดครุย 147-149 ซ.ม."
                    />
                    <Radio
                      mb="md"
                      value="SS"
                      label="ไซส์ SS"
                      description="ความกว้างอก 29-40 นิ้ว ความกว้างช่วงหัวไหล่ 15 นิ้ว ความยาวแขนเสื้อ 22 นิ้ว ความยาวชายชุดครุย 150-155 ซ.ม."
                    />
                    <Radio
                      mb="md"
                      value="S"
                      label="ไซส์ S"
                      description="ความกว้างอก 29-40 นิ้ว ความกว้างช่วงหัวไหล่ 15 นิ้ว ความยาวแขนเสื้อ 22.5 นิ้ว ความยาวชายชุดครุย 156-159 ซ.ม."
                    />
                    <Radio
                      mb="md"
                      value="M"
                      label="ไซส์ M"
                      description="ความกว้างอก 29-40 นิ้ว ความกว้างช่วงหัวไหล่ 16 นิ้ว ความยาวแขนเสื้อ 16.5 นิ้ว ความยาวชายชุดครุย 160-169 ซ.ม."
                    />
                    <Radio
                      mb="md"
                      value="L"
                      label="ไซส์ L"
                      description="ความกว้างอก 29-40 นิ้ว ความกว้างช่วงหัวไหล่ 18 นิ้ว ความยาวแขนเสื้อ 26 นิ้ว ความยาวชายชุดครุย 170-175 ซ.ม."
                    />
                    <Radio
                      mb="md"
                      value="XL"
                      label="ไซส์ XL"
                      description="ความกว้างอก 29-40 นิ้ว ความกว้างช่วงหัวไหล่ 19 นิ้ว ความยาวแขนเสื้อ 26.5 นิ้ว ความยาวชายชุดครุย 160-169 ซ.ม."
                    />
                    <Radio
                      mb="md"
                      value="Outher"
                       label="ไซส์อื่นนอกเหนือจากที่มีในระบบ"
                      error="คิดราคาเพิ่มจากไซส์ปกติ 100 บาท"
                    />
                  </Radio.Group>
                </Grid.Col>
                <Grid.Col span={{base:12, md:12 , xl:12, sm:12 , lg:12}} pr={20} pl={20}>
                  {form.values.set_size === "Outher" ? (
                    <>
                      <Table>
                        <tbody>
                          <tr>
                            <td width={280}>ความกว้างอก</td>
                            <td>
                              <TextInput
                                size="xs"
                                withAsterisk
                                mt="md"
                                placeholder="ความกว้างอก"
                                {...form.getInputProps("set_chest")}
                              />
                            </td>
                            <td>นิ้ว</td>
                          </tr>
                          <tr>
                            <td width={280}>ความกว้างช่วงหัวไหล่</td>
                            <td>
                              <TextInput
                                withAsterisk
                                size="xs"
                                mt="md"
                                placeholder="ความกว้างช่วงหัวไหล่"
                                {...form.getInputProps("set_shoulder")}
                              />
                            </td>
                            <td>นิ้ว</td>
                          </tr>
                          <tr>
                            <td width={280}>ความยาวแขนเสื้อ</td>
                            <td>
                              <TextInput
                                withAsterisk
                                size="xs"
                                mt="md"
                                placeholder="ความยาวแขนเสื้อ"
                                {...form.getInputProps("set_sleeve")}
                              />
                            </td>
                            <td>นิ้ว</td>
                          </tr>
                          <tr>
                            <td width={280}>ความยาวชายชุดครุย</td>
                            <td>
                              <TextInput
                              mt="md"
                                withAsterisk
                                size="xs"
                                placeholder="ความยาวชายชุดครุย"
                                {...form.getInputProps("set_hemshirt")}
                              />
                            </td>
                            <td>ซ.ม.</td>
                          </tr>
                        </tbody>
                      </Table>
                      <Alert
                        icon={<IconAlertCircle size="1rem" />}
                        title="หมายเหตุ"
                        color="red"
                        variant="filled"
                        mt="md"
                      >
                        หากบัณฑิตวัดไซส์ผิดพลาดทางมหาวิทยาลัยจะไม่รับผิดชอบใดๆ ทั้งสิ้น
                      </Alert>
                    </>
                  ) : (
                    <></>
                  )}
                </Grid.Col>
              </Grid>
              <Text c="blue" size="lg" mb="md">
                ระบุการรับชุดครุยวิทยฐานะ
              </Text>
              <Grid>
                <Grid.Col span={{base:12, md:12 , xl:12, sm:12 , lg:12}} pr={20} pl={20}>
                  <Radio.Group
                    {...form.getInputProps("set_sent")}
                    onChange={setSetSent}
                  >
                    <Radio
                      mb="md"
                      value="1"
                      color="red"
                      label="มารับด้วยตนเอง"
                      error="มารับด้วยตนเอง รับได้ที่สำนักบริการวิชาการและจัดหารายได้ (KPRU OTOP) โทร 0622651536 คุณแพรญาภัศช์ ดอนไพวัลย์ และต้องนำใบเสร็จการชำระเงินมาด้วย รับได้วันที่ 16 พฤศจิกายน 2568"
                    />
                    <Radio
                      mb="md"
                      value="2"
                      color="red"
                      label="จัดส่งให้"
                      error="ค่าจัดส่ง 150 บาท"
                    />
                  </Radio.Group>
                </Grid.Col>
              </Grid>
              {form.values.set_sent === "2" ? (
                <>
                  <Text c="blue" size="lg" mb="md">
                    ระบุที่อยู่สำหรับจัดส่งชุดครุยวิทยฐานะ
                  </Text>
                  <Grid>
                    <Grid.Col span={{base:12, md:6 , xl:6, sm:6 , lg:6}} pr={20} pl={20}>
                      {form.values.photo === "1" ? (
                        <Radio.Group
                          {...form.getInputProps("set_copy")}
                          onChange={setSetCopy}
                        >
                          <Radio
                            mb="md"
                            value="1"
                            label="ใช้ที่อยู่เดียวกันกับที่อยู่สำหรับจัดส่งรูปภาพ"
                            disabled={form.values.photo_phone.length === 0}
                          />
                          <Radio mb="md" value="0" label="ที่อยู่อื่น" />
                        </Radio.Group>
                      ) : null}
                      {form.values.set_copy === "0" ||
                      form.values.photo !== "1" ? (
                        <>
                          <TextInput
                            withAsterisk
                            mt="sm"
                            label="บ้านเลขที่"
                            placeholder="บ้านเลขที่"
                            {...form.getInputProps("set_number")}
                          />
                          <TextInput
                            withAsterisk
                            mt="sm"
                            label="หมู่ที่"
                            placeholder="หมู่ที่"
                            {...form.getInputProps("set_moo")}
                          />
                          <TextInput
                            mt="sm"
                            label="ซอย"
                            placeholder="ซอย"
                            {...form.getInputProps("set_soi")}
                          />
                          <TextInput
                            mt="sm"
                            label="ถนน"
                            placeholder="ถนน"
                            {...form.getInputProps("set_street")}
                          />
                        </>
                      ) : (
                        <></>
                      )}
                    </Grid.Col>
                    <Grid.Col span={{base:12, md:6 , xl:6, sm:6 , lg:6}} pr={20} pl={20}>
                      {form.values.set_copy === "0" ||
                      form.values.photo !== "1" ? (
                        <>
                          <Select
                            label="จังหวัด"
                            placeholder="จังหวัด"

                            withAsterisk
                            mt="sm"

                            data={dataProvince}
                            onDropdownClose={() => setDistrictSet([])}
                            {...form.getInputProps("set_privancy")}
                          />
                          <Select
                            label="อำเภอ"
                            placeholder="อำเภอ"

                            withAsterisk
                            mt="sm"
            
                            data={dataDistrict}
                            onDropdownClose={() => setSubDistrictSet([])}
                            onDropdownOpen={loadDistrictSet}
                            {...form.getInputProps("set_district")}
                          />

                          <Select
                            label="ตำบล"
                            placeholder="ตำบล"

                            withAsterisk
                            mt="sm"
                 
                            data={dataSubDistrict}
                            onDropdownOpen={loadSubDistrictSet}
                            {...form.getInputProps("set_subdistrict")}
                          />
                          <TextInput
                            mt="sm"
                            label="รหัสไปรษณีย์"
                            placeholder="รหัสไปรษณีย์"
                            withAsterisk
                            maxLength={5}
                            {...form.getInputProps("set_zipcode")}
                          />
                          <TextInput
                            mt="sm"
                            label="เบอร์โทรศัพท์"
                            placeholder="เบอร์โทรศัพท์"
                            withAsterisk
                            {...form.getInputProps("set_phone")}
                          />
                        </>
                      ) : (
                        <></>
                      )}
                    </Grid.Col>
                  </Grid>
                </>
              ) : (
                <></>
              )}
            </>
          ) : (
            <></>
          )}

          <Group justify="right" mt="md">
            <Button
              type="submit"
              fullWidth
              loading={data.loading}
              variant="gradient"
              gradient={{ from: "teal", to: "lime", deg: 105 }}
            >
              ชำระเงินค่าลงทะเบียน
            </Button>
          </Group>
        </form>
      </section>
    </div>
  );
}
